// extracted by mini-css-extract-plugin
export default {"container":"NUAoEOs2ipHIf0YRQ6gH","label":"F0K5qB8v_gwFTZWylfXp"};